import React, { useState } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";
import Memberships from './Membership/Membership'

export default function GroupsEdit(props) {
  const [group, setGroup] = useState(props.group);
  const [saving, setSaving] = useState(false);
  const allData = props.allData
  const users = props.users
  const projects = props.projects

  const handleSubmit = () => {
    setSaving(true)
    HTTP.patch(`/groups/${props.group.id}`, {
      group: group
    }).then(response => {
      Alert.show("notice", "Group saved!");
      setGroup(response.data);

      setSaving(false);
    }).catch(e => {
      Alert.show("error", "Could not save. Try again or refresh.");
      setSaving(false);
    })
  }

  return (
    <React.Fragment>
      <div className="page-header d-flex align-items-baseline">
        <h4 className="">
          <a href="/groups">
            <i className="fa fa-chevron-left mr-2"></i> Back
          </a>
        </h4>
        <ul className="breadcrumbs">
          <li className="nav-item">
            Groups
          </li>

          <li className="separator">
            <i className="fa fa-arrow-right"></i>
          </li>
          <li className="nav-item">
            {group.name}
          </li>
        </ul>
      </div>
      <div className="card">
        <div className="card-header flex-header">
          <h4 className="card-title">
            Group Editor
          </h4>

          <div>
            <button onClick={handleSubmit} name="button" className="btn btn-primary">
              {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
              Save
            </button>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input className="form-control" placeholder="New Group" type="text" name="name" id="name"
                  value={group.name}
                  onChange={e => {
                    const val = e.target.value;
                    setGroup(group => {
                      return { ...group, name: val }
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Memberships
        groupId = {group.id}
        allData = {allData}
        projects = {projects}
        members = {users}
      />
    </React.Fragment>
  );
}

GroupsEdit.propTypes = {
  group: PropTypes.object
};
